import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconFlex = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconFlex",
  viewBox: "0 0 20 20",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M15.77 11.5a3.6 3.6 0 0 1-2.42 1.1 3.7 3.7 0 0 1-2.55-.83L8.05 9.49a1.73 1.73 0 0 0-2.31.13l-.1.1c-.6.63-.55 1.6.13 2.15l2.65 2.2.38-.4a.8.8 0 0 1 .72-.2c.26.05.48.23.56.46l.9 2.61q.05.12.05.26c0 .38-.33.7-.74.7h-.01l-.16-.02-2.94-.59a.7.7 0 0 1-.56-.47.7.7 0 0 1 .16-.68l.37-.38-2.64-2.19a3.1 3.1 0 0 1-.29-4.6l.11-.12A3.7 3.7 0 0 1 9.3 8.2l2.76 2.27c.67.56 1.7.5 2.3-.12s.55-1.58-.13-2.14L11.5 5.93l-.38.4a.8.8 0 0 1-.71.2.7.7 0 0 1-.56-.46L8.92 3.4a.7.7 0 0 1 .16-.68.8.8 0 0 1 .72-.21l2.93.59q.42.1.56.47c.08.23.02.5-.16.68l-.37.38 2.73 2.25a3.1 3.1 0 0 1 .28 4.62"
  })
}));